import { render } from "./SiteEditor.vue?vue&type=template&id=70cfbb48&scoped=true"
import script from "./SiteEditor.vue?vue&type=script&lang=js"
export * from "./SiteEditor.vue?vue&type=script&lang=js"

import "./SiteEditor.vue?vue&type=style&index=0&id=70cfbb48&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cfbb48"]])

export default __exports__